<template>
  <div v-if="questioner" :key="id">
    <b-row
      v-for="(options_list, index) in questioner"
      :key="uniqueId(index + 'quesi')"
    >
      <b-col lg="12">
        {{ index + 1 }}. {{ options_list.questions_label }}
      </b-col>
      <b-col>
        <pre><ul><b>{{ options_list.answer_label }}</b></ul></pre>
        <p></p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "tab-quesioner",
  components: {},
  props: {
    id: {
      type: String,
      default: "",
    },
    lead_code: {
      type: String,
      default: "",
    },
    questioner: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      admin: localStorage.getItem("admin"),
      isEdit: false,
      isLoading: true,
      isLoadingDetail: false,
      //questioner: [],
    };
  },
  methods: {
    uniqueId: function (param = "") {
      return _.uniqueId(param);
    },
  },
  mounted() {
    // let route = this.$route.path.split("/");
    //this.init();
  },
};
</script>
